import React, { useState, useEffect } from 'react';
import '../styles/Boletines.css';

const Boletines = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [boletinesData, setBoletinesData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/boletines.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('No se pudo cargar el archivo de boletines');
        }
        return response.json();
      })
      .then(data => {
        setBoletinesData(data);
        const years = Object.keys(data);
        if (years.length > 0) {
          const latestYear = years.reduce((max, year) =>
            parseInt(year) > parseInt(max) ? year : max
          );
          setOpenAccordion(latestYear);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar boletines:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const toggleAccordion = (year) => {
    setOpenAccordion(openAccordion === year ? null : year);
  };

  if (error) {
    return (
      <div className="presentation-page pt-16">
        <header className="boletines-hero-section">
          <div className="boletines-hero-content">
            <div className="boletines-hero-container">
              <div className="boletines-hero-card">
                <div className="boletines-hero-grid">
                  <div className="boletines-hero-left">
                    <h1 className="boletines-hero-title">
                      Boletines de
                      <span className="boletines-hero-title-gradient"> Sismicidad</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="boletines-content-section">
          <div className="boletines-content-container">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p style={{ color: '#d32f2f', fontSize: '16px' }}>
                Error al cargar los boletines: {error}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="presentation-page pt-16">
        <header className="boletines-hero-section">
          <div className="boletines-hero-content">
            <div className="boletines-hero-container">
              <div className="boletines-hero-card">
                <div className="boletines-hero-grid">
                  <div className="boletines-hero-left">
                    <h1 className="boletines-hero-title">
                      Boletines de
                      <span className="boletines-hero-title-gradient"> Sismicidad</span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="boletines-content-section">
          <div className="boletines-content-container">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Cargando boletines...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  const years = Object.keys(boletinesData).sort((a, b) => parseInt(b) - parseInt(a));

  const isSearching = searchQuery.trim().length > 0;

  const searchResults = isSearching
    ? years.flatMap(year =>
        boletinesData[year]
          .filter(b =>
            `Boletín ${b.month} ${year}`.toLowerCase().includes(searchQuery.trim().toLowerCase())
          )
          .map(b => ({ ...b, year }))
      )
    : [];

  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="boletines-hero-section">
        <div className="boletines-hero-content">
          <div className="boletines-hero-container">
            <div className="boletines-hero-card">
              <div className="boletines-hero-grid">
                <div className="boletines-hero-left">
                  <h1 className="boletines-hero-title">
                    Boletines de
                    <span className="boletines-hero-title-gradient"> Sismicidad</span>
                  </h1>
                  <h2 className="boletines-hero-subtitle">Catálogos de la actividad por mes o anual en formato PDF</h2>
                </div>
                <div className="boletines-hero-right">
                  <p className="boletines-hero-description">
                    Accede a los boletines mensuales y anuales que documentan la actividad sísmica en el noroeste de México.
                    Estos reportes contienen información detallada sobre la sismicidad registrada por la RESNOM.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Boletines Section */}
      <section className="boletines-content-section">
        <div className="boletines-content-container">
          <div className="boletines-content-grid">
            <div className="boletines-accordion-container">

              {/* Barra de búsqueda */}
              <div className="boletines-search-wrapper">
                <div className="boletines-search-input-wrapper">
                  <i className="fas fa-search boletines-search-icon"></i>
                  <input
                    type="text"
                    className="boletines-search-input"
                    placeholder="Buscar por mes, año o ambos…"
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                  />
                  {searchQuery && (
                    <button
                      className="boletines-search-clear"
                      onClick={() => setSearchQuery('')}
                      aria-label="Limpiar búsqueda"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
                {isSearching && (
                  <p className="boletines-search-count">
                    {searchResults.length > 0
                      ? `${searchResults.length} resultado${searchResults.length !== 1 ? 's' : ''}`
                      : `Sin resultados para "${searchQuery}"`}
                  </p>
                )}
              </div>

              {/* Resultados de búsqueda o Accordion */}
              {isSearching ? (
                searchResults.length > 0 ? (
                  <div className="boletines-search-results">
                    {searchResults.map((item, index) => (
                      <div key={index} className="boletines-link-item">
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="boletines-link"
                        >
                          <i className="fas fa-file-pdf boletines-link-icon"></i>
                          Boletín {item.month} {item.year}
                        </a>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="boletines-no-results">
                    <i className="fas fa-search"></i>
                    <p>No se encontraron boletines para "<strong>{searchQuery}</strong>"</p>
                  </div>
                )
              ) : (
                <div className="boletines-accordion" id="accordionBoletines">
                  {years.map((year) => (
                    <div key={year} className="boletines-accordion-item">
                      <h6 className="boletines-accordion-header" id={`heading${year}`}>
                        <button
                          className={`boletines-accordion-button ${openAccordion === year ? 'active' : ''}`}
                          type="button"
                          onClick={() => toggleAccordion(year)}
                          aria-expanded={openAccordion === year}
                          aria-controls={`collapse${year}`}
                        >
                          Boletines {year}
                          <i className={`boletines-accordion-icon ${openAccordion === year ? 'fa-minus' : 'fa-plus'}`}></i>
                        </button>
                      </h6>
                      <div
                        className={`boletines-accordion-collapse ${openAccordion === year ? 'show' : ''}`}
                        id={`collapse${year}`}
                        aria-labelledby={`heading${year}`}
                      >
                        <div className="boletines-accordion-body">
                          {boletinesData[year].map((boletin, index) => (
                            <div key={index} className="boletines-link-item">
                              <a
                                href={boletin.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="boletines-link"
                              >
                                <i className="fas fa-file-pdf boletines-link-icon"></i>
                                Boletín {boletin.month} {year}
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="boletines-info-container">
              <div className="boletines-info-card">
                <h3 className="boletines-info-title">
                  ¿Qué contienen los
                  <span className="boletines-info-title-gradient"> Boletines?</span>
                </h3>
                <p className="boletines-info-description">
                  Los boletines mensuales de la RESNOM incluyen información detallada sobre:
                </p>

                <div className="boletines-info-item">
                  <div className="boletines-info-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="boletines-info-content">
                    <h4 className="boletines-info-subtitle">Localizaciones</h4>
                    <p>Coordenadas geográficas de los eventos sísmicos registrados</p>
                  </div>
                </div>

                <div className="boletines-info-item">
                  <div className="boletines-info-icon">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <div className="boletines-info-content">
                    <h4 className="boletines-info-subtitle">Magnitudes</h4>
                    <p>Valores de magnitud calculados para cada evento sísmico</p>
                  </div>
                </div>

                <div className="boletines-info-item">
                  <div className="boletines-info-icon">
                    <i className="fas fa-calendar-alt"></i>
                  </div>
                  <div className="boletines-info-content">
                    <h4 className="boletines-info-subtitle">Estadísticas</h4>
                    <p>Resúmenes mensuales y análisis de la actividad sísmica</p>
                  </div>
                </div>

                <div className="boletines-info-item">
                  <div className="boletines-info-icon">
                    <i className="fas fa-download"></i>
                  </div>
                  <div className="boletines-info-content">
                    <h4 className="boletines-info-subtitle">Descarga Gratuita</h4>
                    <p>Todos los boletines están disponibles para descarga gratuita en formato PDF</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Boletines;
